export const shareReplayComponentConfig = {
  bufferSize: 1,
  refCount: true,
};
